import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Linqset, MODEL_TYPE } from '../../common/linqset-model';
import { Organisation, TagGroup } from '../../common/organisation';
import { FUNCTION } from '../../model-services/function.service';
import { SCREEN } from '../../layouts/layouts-enums';
import { AppComponent } from '../../app.component';
import { GraphComponent } from '@yfiles/yfiles';

@Component({
    selector: 'app-graph-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css'],
    standalone: false
})
export class ToolbarComponent {
    @Input() organisation:Organisation
    @Input() graphComponent: GraphComponent;
    @Input() linqset: Linqset;
    @Input() screen:SCREEN
    @Input() readOnly: boolean;
    @Input() modelType:MODEL_TYPE
    @Input() highlights:FUNCTION[]
    @Input() canCompare = false      // the model has changed in this project, so can be compared with current state
    @Input() comparing = false       // it is being compared just now
    @Input() functions:FUNCTION[]   // which functions to show
    @Input() selectedTagGroup: TagGroup

    MODEL_TYPE=MODEL_TYPE

    @Output() toolbarEvent = new EventEmitter<{function:FUNCTION, value?:any}>();

    constructor(public app:AppComponent) {
    }

    handleToolbarEvent(event) {
        this.toolbarEvent.emit(event)
    }
}
